<template>
  <div class="chat_room_internet_commerce_item_wrap">
    <div class="chat_room_internet_commerce_item">
      <div class="chat_table_box">
        <div class="chat_table_ttl">
          KT 프로모션 <br />인터넷 상담을 시작합니다.
        </div>
        <div class="chat_table_sub">
          작성일: {{ getCreateAt(internetCommerceKT2408Model.userCreatedAt) }}
        </div>
      </div>
      <div class="chat_table_box">
        <dl>
          <dt class="color_3">가입유형</dt>
          <dd class="color_6 no_wrap">
            {{ internetCommerceKT2408Model.userJoinType }}
          </dd>
        </dl>
        <dl>
          <dt>희망업체</dt>
          <dd class="color_6" v-if="internetCommerceKT2408Model.userTelecom">
            {{ internetCommerceKT2408Model.userTelecom }}
          </dd>
          <dd class="color_6" v-else>-</dd>
        </dl>
        <dl>
          <dt>희망상품</dt>
          <dd class="color_6 no_wrap">
            {{ internetCommerceKT2408Model.userItemUse }}
          </dd>
        </dl>
        <dl>
          <dt>희망속도</dt>
          <dd class="color_6">
            {{ internetCommerceKT2408Model.userSpeed || '선택안함' }}
          </dd>
        </dl>
      </div>
      <div class="chat_table_box top_line">
        <dl>
          <dt class="color_1 font_bold">월 요금</dt>
          <dd class="font_bold">
            <div class="color_5">
              <div>
                <span class="font_normal color_7 line_through small_font_size"
                  >{{
                    getPromotionOrgPrice(internetCommerceKT2408Model) | comma
                  }}원</span
                >
                <span class="font_normal color_7"> > </span>
                <span
                  >{{
                    getPromotionSalePrice(internetCommerceKT2408Model) | comma
                  }}원</span
                >
              </div>
            </div>
          </dd>
        </dl>
        <dl v-if="getViewDate(internetCommerceKT2408Model.userCreatedAt)">
          <dt class="color_1 font_bold">
            설치비
          </dt>
          <dd class="font_bold">
            <div class="color_5">
              <div>
                <span class="font_normal color_7 small_font_size">
                  [무료프로모션]
                </span>
                <span>0원</span>
              </div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt class="color_1 font_bold">
            총 혜택<span class="font_normal color_7">(3년간)</span>
          </dt>
          <dd class="color_5 font_bold">
            {{ getTotalPrice(internetCommerceKT2408Model) | comma }}원
          </dd>
        </dl>
        <dl>
          <dt></dt>
          <dd class="color_6 font_bold">
            <div class="font_normal color_7 small_font_size">
              요금할인(퍼스특별)
              {{
                getPromotionSupportPrice(internetCommerceKT2408Model) | comma
              }}원
            </div>
            <div class="font_normal color_7 small_font_size">
              상품권
              {{ getPromotionGiftPrice(internetCommerceKT2408Model) | comma }}원
            </div>
          </dd>
        </dl>
      </div>
      <div
        class="chat_table_box top_line"
        v-if="internetCommerceKT2408Model.ownerMemoSupport.length > 0"
      >
        <div
          class="color_3"
          v-html="
            $options.filters.nl2br(internetCommerceKT2408Model.ownerMemoSupport)
          "
        ></div>
      </div>
    </div>
    <button
      class="btn bo fw800"
      @click.stop.prevent="formApply()"
      v-if="isCustomer"
    >
      가입신청서 작성하기
    </button>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import promotionCfg from '@common/lib/common/promotionCfg';
export default {
  props: {
    internetCommerceKT2408Model: Object,
    createdAt: String,
    isCustomer: Boolean,
    chatroom: Object,
  },
  data() {
    return {
      monthOrgPrice: 0,
      monthSalePrice: 0,
      supportPrice: 0,
      giftPrice: 0,
    };
  },
  mounted() {},
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  methods: {
    toCurrency(val) {
      return util.toCurrency(val);
    },
    getCreateAt(createAt) {
      return format(parseISO(createAt), 'yyyy-MM-dd');
    },
    getTotalPrice(item) {
      console.log('getTotalPrice');
      console.log(item);
      let telecomItem = this.getPromotionItem(item);

      let promotionInfo = promotionCfg.getPriceInfo(
        item.ownerTelecom,
        telecomItem,
      );

      console.log(promotionInfo);
      return promotionInfo.support + promotionInfo.gift;
    },
    getPromotionOrgPrice(item) {
      console.log('getPromotionOrgPrice');
      console.log(item);
      let telecomItem = this.getPromotionItem(item);

      return promotionCfg.getMonthOrgPrice(item.ownerTelecom, telecomItem);
    },
    getPromotionSalePrice(item) {
      let telecomItem = this.getPromotionItem(item);

      return promotionCfg.getMonthSalePrice(item.ownerTelecom, telecomItem);
    },
    getPromotionSupportPrice(item) {
      let telecomItem = this.getPromotionItem(item);

      return promotionCfg.getMonthSupportPrice(item.ownerTelecom, telecomItem);
    },
    getPromotionGiftPrice(item) {
      let telecomItem = this.getPromotionItem(item);

      return promotionCfg.getMonthGiftPrice(item.ownerTelecom, telecomItem);
    },
    getPromotionItem(item) {
      let itemArr = '';
      let telecomItem = '';
      if (item.ownerItem == '100M 인터넷') {
        itemArr = item.ownerItem.split(' ');
        telecomItem = itemArr[0];
      } else {
        itemArr = item.ownerItem.split('+');
        if (itemArr[0].indexOf('100M') != -1) {
          telecomItem = '100M';
        } else if (itemArr[0].indexOf('500M') != -1) {
          telecomItem = '500M';
        }

        if (itemArr[1].indexOf('TV') != -1) {
          telecomItem += '+TV';
        }
      }
      return telecomItem;
    },
    formApply() {
      this.$router.push({
        name: 'InternetCommerce.ApplyForm',
        params: {
          mode: 'submit',
          storeId: this.internetCommerceKT2408Model.storeId,
          icqId: this.internetCommerceKT2408Model.icqId,
        },
      });
    },
    getViewDate(createDate) {
      const limitDate = format(new Date('2025-03-05'), 'yyyy-MM-dd');
      const today = format(new Date(), 'yyyy-MM-dd');
      const createdAt = format(new Date(createDate), 'yyyy-MM-dd');

      if (limitDate <= today && limitDate <= createdAt) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style></style>
